import React from 'react';
import PropTypes from 'prop-types';
import NextivaSurveyAlreadyTakenMessage from './NextivaSurveyAlreadyTakenMessage';
import takerMessageComponentTypes from '../config/takerMessageComponentTypes';

const customMessageComponents = {
  [takerMessageComponentTypes.nextivaSurveyAlreadyTaken]: NextivaSurveyAlreadyTakenMessage,
};

const TakerMessageComponent = ({ componentType }) => {
  const CustomMessageComponent = customMessageComponents[componentType];

  return <CustomMessageComponent />;
};

TakerMessageComponent.propTypes = {
  componentType: PropTypes.string.isRequired,
};

export default TakerMessageComponent;
